enum VideoPlayerIds {
  VideoContainer = 'sendspark-video-container',
  VideoPlayer = 'sendspark-video-player',
  ButtonPlay = 'sendspark-video-player-button-play',
  ButtonVolume = 'sendspark-video-player-button-volume',
  ButtonPlaybackRate = 'sendspark-video-player-button-playback-rate',
  InputVolumeRange = 'sendspark-video-player-input-volume-range',
  ButtonFullscreen = 'sendspark-video-player-button-fullscreen',
  ProgressBar = 'sendspark-video-player-progress-bar',
}

export default VideoPlayerIds;
